import React, { startTransition, useState } from 'react';
import styles from './index.module.less';
import { Input } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { LoadingOutlined } from '@ant-design/icons';

export default function ReverseUsername() {
  const router = useRouter();
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [showError, setShowError] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  // ✅ INP 优化 + 修复逻辑错误：
  // 问题1：setIsSearching(true) 在 router.push 之后 → 防抖失效，页面卸载时状态无效
  // 问题2：router.push 同步执行 → 阻塞主线程 100-300ms
  // 优化后：先设置 loading 状态 + 使用 startTransition 降低路由优先级
  const handleSearch = () => {
    if (isSearching) return;
    if (!username.trim()) {
      setShowError(true);
      return;
    }

    // ✅ 修复顺序：先设置 loading 状态，再跳转
    setShowError(false);
    setIsSearching(true);

    // ✅ 使用 startTransition 包装路由跳转
    startTransition(() => {
      router.push(`/content-monitoring/reverse-username-search?name=${username}`);
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
    if (e.target.value.trim()) {
      setShowError(false);
    } else {
      setShowError(true);
    }
  };

  return (
    <>
      {/* 标题 */}
      <div className={styles.title}>{t('Reverse Username Search')}</div>

      {/* 搜索区域 */}
      <div className={styles.searchArea}>
        <div className={styles.searchAreaInner}>
          <div className={`${styles.inputWrapper} ${showError ? styles.error : ''}`}>
            <Input
              placeholder={t('Please enter a username')}
              value={username}
              onChange={handleInputChange}
              onPressEnter={handleSearch}
            />
          </div>
          <div className={styles.buttonWrapper}>
            <button onClick={handleSearch} className={styles.searchButton} disabled={isSearching}>
              {/* ✅ 显示 loading 图标 */}
              {isSearching ? (
                <LoadingOutlined style={{ marginRight: 8, fontSize: 20 }} />
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22.5 12.5C22.5 6.97688 18.0231 2.5 12.5 2.5C6.97688 2.5 2.5 6.97688 2.5 12.5C2.5 18.0231 6.97688 22.5 12.5 22.5C18.0231 22.5 22.5 18.0231 22.5 12.5ZM12.0288 13.8681H11C8 13.8681 7.14875 15.7087 7.14875 15C7.14875 14.2912 8 11.3006 11.5 11.3006H12.0288V8.69438L17.78 12.585L12.0288 16.4756V13.8681Z"
                    fill="white"
                  />
                </svg>
              )}
              <span>{t('Search Now')}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
